import { HttpService } from "@sportal/api";
import { APIConfig } from "./api.types";

export class BaseApiService {
  _http: HttpService;

  constructor(config: APIConfig) {
    this._http = config.http;
  }
}
